import { render, staticRenderFns } from "./VrsteTema2.vue?vue&type=template&id=43edb7e4&scoped=true&"
import script from "./VrsteTema2.vue?vue&type=script&lang=js&"
export * from "./VrsteTema2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43edb7e4",
  null
  
)

export default component.exports